import { useEffect } from 'react';
import { getReplay } from '.';
export function usePauseSessionReplay() {
    useEffect(() => {
        const replay = getReplay();
        const isRecording = Boolean(replay === null || replay === void 0 ? void 0 : replay.getReplayId());
        if (!replay || !isRecording) {
            return undefined;
        }
        replay.stop();
        return () => {
            replay.start();
        };
    }, []);
}
